import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import IconButton from '@mui/material/IconButton';
import { useCallback } from 'react';
import { isMobile } from 'react-device-detect';
import { shallowEqual } from 'react-redux';
import { ALL_GAME_GUIDE_PAGES } from '../../gameGuide/gameGuidePages';
import { goBackInGameGuide, goForwardInGameGuide, thunkGoToGameGuidePage } from '../../redux/actions/gameGuideActions';
import { useAppDispatch, useAppSelector } from '../../redux/store';
import { isTestEnvironment } from '../../utils/utils';
import { OpenModalContainer } from '../openModalContainer';
import { TwemojiWrapper } from '../twemojiWrapper';
export const GameGuideModal = ({ onClose }) => {
    const dispatch = useAppDispatch();
    const pageIndex = useAppSelector((state) => state.gameGuide.pageIndex);
    const pageHistory = useAppSelector((state) => state.gameGuide.pageHistory, shallowEqual);
    const onClickHome = useCallback(() => {
        dispatch(thunkGoToGameGuidePage('home'));
    }, [dispatch]);
    const onClickBack = useCallback(() => {
        dispatch(goBackInGameGuide());
    }, [dispatch]);
    const onClickForward = useCallback(() => {
        dispatch(goForwardInGameGuide());
    }, [dispatch]);
    const onClickOpenLink = useCallback(() => {
        onClose();
        const target = !isTestEnvironment() ? '_blank' : '_self';
        window.open(`guide/${pageHistory[pageIndex]}`, target);
    }, [onClose, pageHistory, pageIndex]);
    const page = pageHistory[pageIndex];
    const { title, content } = ALL_GAME_GUIDE_PAGES[page];
    const additionalControls = (_jsxs(_Fragment, { children: [_jsx(IconButton, { title: 'Game Guide Home', onClick: onClickHome, disabled: page === 'home', size: 'large', children: _jsx(HomeRoundedIcon, {}) }), _jsx(IconButton, { title: 'Back', onClick: onClickBack, disabled: pageIndex <= 0, size: 'large', children: _jsx(ArrowBackRoundedIcon, {}) }), _jsx(IconButton, { title: 'Forward', onClick: onClickForward, disabled: pageIndex >= pageHistory.length - 1, size: 'large', children: _jsx(ArrowForwardRoundedIcon, {}) }), !isMobile && (_jsx(IconButton, { title: 'Open Link', onClick: onClickOpenLink, size: 'large', children: _jsx(LaunchRoundedIcon, {}) }))] }));
    return (_jsx(OpenModalContainer
    // using an explicit key forces a re-render of the container, which prevents a new page from remembering the scroll position of the previous page:
    , { title: title, onClose: onClose, maxWidth: 'lg', additionalControls: additionalControls, children: _jsx(DialogContent, { children: _jsx(DialogContentText, { component: 'div', children: _jsx(TwemojiWrapper, { children: content }) }) }) }, page));
};
